import type { FilterDataOption } from '@/app/common/filters/core/filtersTypes.ts';
import { useFiltersUiData } from '@/app/common/filters/surfaces/provider/filtersUiProvider.tsx';
import { formatLabelCounter } from '@/app/common/filters/types/shared/utils/labelCounter.tsx';
import React from 'react';
import { Counter } from '@/app/common/filters/types/shared/styled/Counter.styled.ts';
import { Text } from '@/app/common/filters/types/shared/styled/Text.styled.ts';

type LabelNodeProps = {
  option: Omit<FilterDataOption, 'label'> & {
    label: string | React.JSX.Element;
  };
  isDisabled: boolean;
  showCounter?: boolean;
};

const LabelNode = ({ option, isDisabled, showCounter = true }: LabelNodeProps) => {
  const { customLabelComponents, useEvoFilters, totalResults } = useFiltersUiData();
  // Evo moves the count onto the apply CTA, so the option keeps it only while the API sends no total.
  const countOnCta = !!useEvoFilters && totalResults !== undefined;
  const labelCounter = showCounter && !countOnCta ? formatLabelCounter(option.counter) : undefined;
  const CustomLabelComponent =
    customLabelComponents && option.labelComponent
      ? customLabelComponents?.[option.labelComponent.componentName]
      : undefined;

  return (
    <>
      {CustomLabelComponent ? <CustomLabelComponent {...option.labelComponent?.props} /> : <Text>{option.label}</Text>}
      {labelCounter && <Counter isDisabled={isDisabled}>{labelCounter}</Counter>}
    </>
  );
};

export default LabelNode;
